import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { YimTalkTopBar } from '@/components/yim-talk/YimTalkTopBar';
import { IBANGA_PROMO_URL } from '@/config';

export function YimTalkLayout() {
  const { t } = useTranslation();

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-gradient-to-b from-primary-700 via-primary-800 to-primary-950 text-white">
      <Helmet>
        <title>{t('yimTalk.pageTitle')}</title>
        <meta name="theme-color" content="#1e40af" />
      </Helmet>

      <YimTalkTopBar />

      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <div className="mx-auto flex w-full max-w-lg flex-1 flex-col px-3 pb-6 sm:px-4">
          <Outlet />
          <footer className="mt-auto space-y-3 pt-8 text-center">
            <p className="text-xs leading-relaxed text-white/50">{t('yimTalk.ibangaFooter')}</p>
            <a
              href={IBANGA_PROMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-xs font-bold text-primary-300 hover:text-white focus-visible:ring-2 focus-visible:ring-accent-400"
            >
              {t('yimTalk.ibangaLink')}
            </a>
            <nav className="flex justify-center gap-4 text-xs text-white/40">
              <Link to="/terms" className="hover:text-white/70">
                {t('public.footer.terms')}
              </Link>
              <Link to="/privacy" className="hover:text-white/70">
                {t('public.footer.privacy')}
              </Link>
            </nav>
          </footer>
        </div>
      </main>
    </div>
  );
}

export default YimTalkLayout;
